export const NUMBER_OF_WEEKS_YEAR = 53;
export const NUMBER_OF_WEEKS_LEAP_YEAR = 52;
export const AGENCY_CLOSE_AT = 20;
export const AGENCY_OPEN_AT = 9;
export const DAYS_PER_PAGE = 7;
export const BILAN_SLOT_NOW = "maintenant";
export const MONTH_JULY = "juillet";
export const SHORT_MONTH_JULY = "Jul";
export const IMC_UNIT = "Kg/m²";
